import { Injectable } from '@angular/core';
import { MustacheHelper } from "@app/helpers/mustache.helper";
import { FileUploaderService } from '@app/services';
@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  formState?: any;

  constructor(
    private fileUploaderService: FileUploaderService
  ) {
    this.formState = {}
  }

  getFormImages(form: any) {
    return this.formState[`images_${form?._id}`] || []
  }

  getGroupFormImages(group: any, index: any, form: any) {
    return this.formState[group._id]?.[index]?.[`images_${form?._id}`] || []
  }

  addFormState(formJson: any, formId: string) {
    console.log(formJson)
    this.formState = this.formStateGenerator(formJson, this.formState)
    if (formJson["form_design"].logic != null && formJson["form_design"].logic != "") {
      if (!this.formState["logic"]) this.formState["logic"] = {};
      this.formState["logic"][formId] = {
        formId: formId,
        logic: formJson["form_design"].logic
      }
    }
  }

  addRecursiveFormState(formJson: any, formId: string) {
    let recurFormState = this.formStateGenerator(formJson, {})

    this.formState["function"] = (this.formState["function"] || []).concat(recurFormState["function"])
    delete recurFormState["function"];

    this.formState = {
      ...this.formState,
      [formId]: [recurFormState]
    }
  }

  /**
   * Generates form state with all input values
   * @param formJson 
   * @returns formState
   */
  private formStateGenerator(formJson: any, formState: any = {}) {
    const ELEMENTS = {
      INPUT: "input",
      CHECKBOX: "checkbox",
      TOGGLE: "toggle",
      TEXT_AREA: "textarea",
      DROP_DOWN: "dropdown",
      RADIO: "radios",
      TABLE: "table",
      OUTPUT: 'output'
    }
    let components = []

    if (formJson["added_components"]) components = formJson["added_components"]
    if (formJson["addedComponents"]) components = formJson["addedComponents"]

    for (let component of components) {
      if (Array.isArray(component)) {
        this.formStateGenerator({ added_components: component }, formState)
        continue
      }

      let el = component.element
      if (component.machineName == ELEMENTS.INPUT) {
        formState[el.field_name] = component.type == "number" ? 0 : null
      }
      if (component.machineName == ELEMENTS.TEXT_AREA) {
        formState[el.field_name] = ""
      }
      if (component.machineName == ELEMENTS.DROP_DOWN || component.machineName == ELEMENTS.RADIO) {
        formState[el.field_name] = null
      }
      if (component.machineName == ELEMENTS.CHECKBOX || component.machineName == ELEMENTS.TOGGLE) {
        formState[el.field_name] = false
      }
      if (component.machineName == ELEMENTS.TABLE) {
        let firstRow: any = {}
        formState[el.field_name] = [firstRow]

        for (let col of el.columns) {
          let temp: any;
          if (col.valueType == 'number') {
            temp = 0
          } else if (col.valueType == 'text') {
            temp = ""
          } else if (col.valueType == ELEMENTS.CHECKBOX || col.valueType == ELEMENTS.TOGGLE) {
            temp = false
          } else if (col.valueType == 'date') {
            temp = "2023-12-12"
          }
          firstRow[col.name + '_' + col.id] = temp
        }

      }
      if (component.machineName == ELEMENTS.OUTPUT) {
        formState[el.field_name] = "0"
        if (!formState["function"]) formState["function"] = [];
        formState["function"].push({
          key: el.field_name,
          formula: el.formula
        })
      }

      this.formStateGenerator(component, formState)
    }

    return formState
  }

  addClientDetails(clientObj: any) {
    this.formState["clientLocations"] = [];
    if (clientObj.locations.length) {
      this.formState["clientLocations"] = clientObj.locations
    }

    this.formState["clientUserFirstname"] = clientObj.user?.firstName ?? ""
    this.formState.clientUserLastname = clientObj.user?.lastName ?? ""
    this.formState.clientExemptGST = clientObj.exemptGST ?? false
    this.formState.clientExemptStampDuty = clientObj.exemptStampDuty ?? false
    this.formState.clientLegalName = clientObj.legalName ?? ""
    this.formState.clientABN = clientObj.ABN ?? ""
    this.formState.clientTradingName = clientObj.tradingName ?? ""
    this.formState.clientWebsite = clientObj.website ?? ""
    this.formState.clientPhone = clientObj.user?.phone ?? ""

    console.log("#form satte", this.formState)
  }

  async stateChange({ component, eventType, row, col, value, formId, formRow }: any) {
    let curFormState = this.formState
    console.log("@form state - ", this.formState)
    console.log("@event - ", { component, eventType, row, col, value, formId, formRow })

    if (eventType == 'removeFile') {
      if (formId != null && formRow != null) {
        curFormState = this.formState[formId][formRow]
        let subFormId = component.element.field_name
        curFormState[`images_${subFormId}`].splice(row, 1)
        return;
      }
      curFormState[`images_${formId}`].splice(row, 1)
      return;
    }

    if (eventType == 'addComment') {
      if (formId != null && formRow != null) {
        curFormState = this.formState[formId][formRow]
        let subFormId = component.element.field_name
        curFormState[`images_${subFormId}`][row]["comment"] = value;
        return;
      }
      curFormState[`images_${formId}`][row]["comment"] = value
      return;
    }

    if (eventType == 'addFile') {
      if (formId != null && formRow != null) {
        curFormState = this.formState[formId][formRow]
        let subFormId = component.element.field_name

        if (curFormState[`images_${subFormId}`] == null) {
          curFormState[`images_${subFormId}`] = []
        }
        let fileUrl: any = await this.fileUploaderService.uploadUsingPreSignedUrl({
          fileName: value.name,
          contentType: value.type,
          file: value
        })
        curFormState[`images_${subFormId}`].push({
          url: fileUrl?.url
        })
  
        console.log(this.formState)

        return;
      }
      if (curFormState[`images_${formId}`] == null) {
        curFormState[`images_${formId}`] = []
      }
      let fileUrl: any = await this.fileUploaderService.uploadUsingPreSignedUrl({
        fileName: value.name,
        contentType: value.type,
        file: value
      })
      curFormState[`images_${formId}`].push({
        url: fileUrl?.url
      })

      console.log(this.formState)

      return;
    }

    if(eventType == "removeGroup") {
      curFormState[formId].splice(formRow, 1)
    }

    if (eventType == "AddRecursiveForm") {
      if (!this.formState[formId]) {
        this.formState[formId] = []
      }
      this.formState[formId].push({
        name: value + ` #${(this.formState[formId]?.length || 0) + 1}`
      })
      return;
      // this.formState[formId].push(JSON.parse(JSON.stringify(this.formState[formId]?.[0] || '{}')))
    }
    
    if( eventType == "RemoveRecursiveForm" ) {
      if (!this.formState[formId]) {
        this.formState[formId] = []
      }
      debugger
      this.formState[formId].splice(formRow, 1)
      return;
    }

    // to handle recursive forms
    if (formId && formRow != null) {
      curFormState = this.formState[formId][formRow]
    }

    if (eventType == "rowAdd") {
      if (!curFormState[component.element.field_name]) {
        curFormState[component.element.field_name] = []
      }
      curFormState[component.element.field_name].push({})
      return;
    }
    if (eventType == "rowRemove") {
      if (!curFormState[component.element.field_name]) {
        curFormState[component.element.field_name] = []
      }
      if(curFormState[component.element.field_name].length > 1) {
        curFormState[component.element.field_name].pop()
      }
      return;
    }
    if (eventType == 'valueChange') {
      if (component.machineName == 'table') {
        curFormState[component.element.field_name][row][col.name + "_" + col.id] = value
      } else {
        curFormState[component.element.field_name] = value
      }
    }

    if (this.formState["logic"] != null) {
      let result = {};
      let formLogics: any;

      for (formLogics of Object.values(this.formState["logic"])) {
        let tempFunction = new Function("state", formLogics.logic)
        let tempResult = tempFunction(this.formState)
        let tempResultObj = JSON.parse(tempResult)
        result = {
          ...result,
          ...tempResultObj
        }
      }


      if (result) {
        this.formState = {
          ...this.formState,
          ...result
        }
      }
    }

    this.formState?.["function"]?.forEach((obj: any) => {
      if (!obj?.key || !obj?.formula) return
      this.formState[obj.key] = MustacheHelper.evaluate(obj.formula, this.formState)
    })

    this.formState = {
      ...this.formState
    }
  }

  flushState() {
    this.formState = {}
  }
}
